import { BaseApi, enhanceOpt } from '../couplingAjax'
import { Services } from '@/store/StoreTypes'

const Scrm_sys_api = (request: typeof BaseApi, SERVIVE: Services) => {
  return {
    srcmLogin: {
      //判断用户是否需要进入引导页
      getJudgeUserGuidePages: (opt: enhanceOpt) => {
        const __user = sessionStorage.getItem('__user')
        let info = null
        if (__user) {
          info = JSON.parse(__user + '')
        }
        return request({
          ...opt,
          url: `/user/judgeUserGuidePages`,
          headers: { 'Content-Type': 'application/json;charset=UTF-8', token: info.user.token },
          method: 'post',
        })
      },
      //根据token获取userInfo
      getUserInfo: (opt: enhanceOpt) =>
        request({
          ...opt,
          url: `/user/getUserAllInfoByToken`,
          method: 'post',
        }),

      getUserInfoByToken: (opt: enhanceOpt) => {
        let info = null
        if (sessionStorage.getItem('__user')) {
          info = JSON.parse(sessionStorage.getItem('__user') + '')
        }
        return request({
          // token: info.user.token,
          ...opt,
          url: `/user/getUserInfoByToken`,
          method: 'post',
        })
      },
      // 合伙人详情
      getPartnerInfo: (opt: enhanceOpt) => {
        const __user = sessionStorage.getItem('__user')
        let info = null
        if (__user) {
          info = JSON.parse(__user + '')
        }
        return request({
          ...opt,
          url: `/partner/detail`,
          headers: { 'Content-Type': 'application/json;charset=UTF-8', token: info.user.token },
          method: 'get',
        })
      },
      //获取图片验证码
      pictureVerify: (sessionId: string) => {
        return `/${SERVIVE.scrm_sys_api}/user/captcha?sessionId=${sessionId}`
      },
      //账号登录
      in: (opt: enhanceOpt, sessionId: string) =>
        request({
          ...opt,
          url: `/user/login?sessionId=${sessionId}`,
          method: 'post',
        }),
      //短信登录
      SmsIn: (opt: enhanceOpt, sessionId: string) =>
        request({
          ...opt,
          url: `/user/smsLogin?sessionId=${sessionId}`,
          method: 'post',
        }),
      //创建企业及游客登录
      CreateAndLogin: (opt: enhanceOpt, sessionId: string) =>
        request({
          ...opt,
          url: `/user/createAndLogin`,
          method: 'post',
        }),
      //短信验证码
      msgVerify: (opt: enhanceOpt, phone: string, areaCode: any) =>
        request({
          ...opt,
          url: `/user/sendSms?phone=${phone}&areaCode=${areaCode}`,
          method: 'post',
        }),
      //获取邮箱验证码
      emailVerify: (opt: enhanceOpt, sessionId: string) =>
        request({
          ...opt,
          url: `/digitalUser/sendEmailCode`,
          method: 'post',
        }),
      //忘记密码
      resetPasswd: (opt: enhanceOpt) =>
        request({
          ...opt,
          url: `/user/resetPasswd`,
          method: 'post',
        }),
      //忘记密码
      resetPasswdByEmail: (opt: enhanceOpt) =>
        request({
          ...opt,
          url: `/user/resetPasswdByEmail`,
          method: 'post',
        }),
      //数字人邮箱版本忘记密码
      digitalResetPasswd: (opt: enhanceOpt) =>
        request({
          ...opt,
          url: `/digitalUser/resetPassword`,
          method: 'post',
        }),
      //设置密码/重置密码
      setPasswd: (opt: enhanceOpt) => {
        const __user = sessionStorage.getItem('__user')
        let info = null
        if (__user) {
          info = JSON.parse(__user + '')
        }
        return request({
          ...opt,
          url: `/user/setPasswd`,
          headers: { 'Content-Type': 'application/json;charset=UTF-8', token: info.user.token },
          method: 'post',
        })
      },
      tokenCheck: (opt?: enhanceOpt) => {
        const __user = sessionStorage.getItem('__user')
        let info = null
        if (__user) {
          info = JSON.parse(__user + '')
        }
        return request({
          ...opt,
          url: '/user/tokenCheck',
          headers: { 'Content-Type': 'application/json;charset=UTF-8', token: info.user.token },
          method: 'post',
        })
      },
      loginOut: (opt: enhanceOpt) => {
        const __user = sessionStorage.getItem('__user')
        let info = null
        if (__user) {
          info = JSON.parse(__user + '')
        }
        return request({
          ...opt,
          url: `/user/logout`,
          headers: { 'Content-Type': 'application/json;charset=UTF-8', token: info.user.token },
          method: 'post',
        })
      },
      bindingRegisterCodeCheck: (opt: enhanceOpt, mobile: string, errorIfNotExist: boolean) => {
        return request({
          ...opt,
          url: `/digitalUser/isBindRegisterCode/${mobile}?errorIfNotExist=${errorIfNotExist}`,
          method: 'get',
        })
      },
      usernameCheck: (opt: enhanceOpt, username: string) => {
        return request({
          ...opt,
          // url: `/user/checkExist/${username}`,
          url: `/user/checkExist?username=${username}`,
          method: 'get',
        })
      },
      getUserTypes: (opt: enhanceOpt) => {
        const __user = sessionStorage.getItem('__user')
        let info = null
        if (__user) {
          info = JSON.parse(__user + '')
        }

        return request({
          ...opt,
          url: `/user/getUserTypes`,
          headers: { 'Content-Type': 'application/json;charset=UTF-8', token: info.user.token },
          method: 'get',
        })
      },
      changeRole: (opt: enhanceOpt, role: number) => {
        const __user = sessionStorage.getItem('__user')
        let info = null
        if (__user) {
          info = JSON.parse(__user + '')
        }

        return request({
          ...opt,
          url: `/digitalUser/switchRole/${role}`,
          headers: { 'Content-Type': 'application/json;charset=UTF-8', token: info.user.token },
          method: 'get',
        })
      },
      // 生成微信授权登录验证码
      getWxQrCode: (type: number) => {
        return request({
          url: `/user/wx/qrCode?type=${type}`,
          method: 'get',
        })
      },
      wxLogin: (code: string) => {
        return request({
          url: `/user/wx/login?code=${code}`,
          method: 'get',
        })
      },
      wxUnbinding: (opt: enhanceOpt) => {
        return request({
          ...opt,
          url: `/user/wx/unbinding`,
          method: 'get',
        })
      },
      wxBinding: (opt: enhanceOpt, code: string) => {
        return request({
          ...opt,
          url: `/user/wx/binding?code=${code}`,
          method: 'get',
        })
      },
      // 企业认证
      registerCorp: (opt: enhanceOpt) => {
        return request({
          ...opt,
          url: `/corp/registerCorp`,
          method: 'post',
        })
      },
      queryEntEditionInfoByCorpId: (opt: enhanceOpt) => {
        return request({
          ...opt,
          url: `/corp/queryEntEditionInfoByCorpId`,
          method: 'get',
        })
      },
    },
    userDetect: {
      submitDetect(data) {
        const __user = sessionStorage.getItem('__user')
        let info = null
        if (__user) {
          info = JSON.parse(__user + '')
        }
        return request({
          data,
          headers: {
            token: info.user.token
          },
          url: '/user/add_destroying_guiyu_pc',
          method: 'POST'
        })
      },
      undoDetect(data) {
        const __user = sessionStorage.getItem('__user')
        let info = null
        if (__user) {
          info = JSON.parse(__user + '')
        }
        return request({
          headers: {
            token: info.user.token
          },
          url: `/user/cancel_destroying_guiyu_pc?id=${data.id}`,
          method: 'GET'
        })
      }
    }
  }
}

export default Scrm_sys_api
